<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.rates.headerTitle')" />

    <div class="base-container-first rates__wrapper ui-scrollbar-primary">
      <div class="base-content-block">
        <RateConfigurator
          v-if="list.length"
          :rate="list[0]"
        />
      </div>

      <RateMigrationCTA />

      <div class="difference">
        <h3
          class="question-title typography__headline2"
          v-html="t('pages.rates.faq.title')"
        />

        <RateQuestions />
      </div>
    </div>
  </section>

  <div style="background-color: var(--white)">
    <ContactOrderForm
      :description="t('pages.rates.contactForm.description')"
      :title="t('pages.rates.contactForm.title')"
    />
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { list } = await useGetRateListDto();

useSeoMeta({
  title: t("pages.rates.seo.title"),
});
</script>

<style scoped>
.rates__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .rates__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.rate-title {
  max-width: 370px;
}

@media (--desktop) {
  .rate-title {
    max-width: 535px;
    font-size: 60px;
    line-height: 1.1;
  }
}

.difference {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  width: 100%;
}

@media (--desktop) {
  .difference {
    row-gap: 60px;
  }
}

.question-title {
  max-width: 300px;
}

@media (--desktop) {
  .question-title {
    max-width: 535px;
    font-size: 60px;
    line-height: 1.1;
  }
}

:deep(.migration-cta) {
  background-color: var(--white);
}

:deep(.form-questions) {
  background-color: var(--white);
}

:deep(.configurator__result) {
  background-color: var(--white);
}
</style>
